// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Toasted from 'vue-toasted'
import App from './App'
import { library } from '@fortawesome/fontawesome-svg-core';
import { faPaperPlane, faCoffee, faTrash, faPlaneSlash, faPlay, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import '@bchteam/vue-jivosite';

library.add(faPaperPlane, faCoffee, faTrash, faPlaneSlash, faPlay, faArrowRight);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false

Vue.use(Toasted, {
  duration: 7000,
  position: 'bottom-center',
  theme: 'bubble',
  singleton: true,
  fitToScreen: true,
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js